<script setup lang="ts">
const props = defineProps({
  quote: {
    type: String as PropType<string>,
    required: true,
  },
});

const quote = useSimpleQuoteToQuoteType(props.quote);
</script>

<template>
  <blockquote
    class="quote"
    :aria-label="
      quote.author && quote.company
        ? `sitat av ${quote.author} ${quote.company}`
        : `sitat`
    "
  >
    <IconsGraphicsQuoteSymbol
      class="quote__symbol"
      fill="var(--background)"
      width="60"
      aria-hidden="true"
    />
    <mark class="quote__text headline" v-html="quote.body" />
    <div
      v-if="quote.author"
      class="quote__author"
      aria-hidden="true"
    >
      <mark>{{ quote.author }}</mark>
    </div>
    <div
      v-if="quote.company"
      class="quote__role"
      aria-hidden="true"
    >
      <mark>{{ quote.company }}</mark>
    </div>
  </blockquote>
</template>

<style scoped lang="scss">
.quote {
  width: 100%;
  margin: 4rem auto;
  position: relative;
  line-height: pixelsToRem(30);

  mark {
    color: theme("colors.green.50");
  }

  .quote__text {
    font-size: pixelsToRem(25);
    line-height: pixelsToRem(45);
    margin: 8rem 0;
    font-weight: 400;

    @media screen and (min-width: $small) {
      font-size: pixelsToRem(35);
      line-height: pixelsToRem(52);
    }
  }

  .quote__author {
    margin-top: 0.8rem;
    font-size: pixelsToRem(18);
  }
  .quote__role {
    font-size: pixelsToRem(16);
  }

  .quote__symbol {
    display: none;

    @media screen and (min-width: $small) {
      display: block;
      position: absolute;
      left: -5rem;
      top: -2rem;
    }
  }

  mark {
    background-color: color-mix(in oklab, var(--foreground) 30%, transparent 100%);
    padding: 0.2rem;
  }
}
</style>
